import { endpoints } from '../endpoints';
import { parseResponse } from '../parseResponse';
import { getHeader } from './generalApi';

export async function getSearchResults(requestData) {
  return fetch(`${endpoints.search}`, {
    ...(await getHeader('POST')),
    body: JSON.stringify(requestData)
  }).then(parseResponse);
}
